// extracted by mini-css-extract-plugin
module.exports = {"root":"Choice_root__37fbF","dragIcon":"Choice_dragIcon__DCPWo","left":"Choice_left__3uH-B","input":"Choice_input__2vZHi"};